export const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://zamon.al-electronics.uz/' : 'http://192.168.0.39:8001/'
const API_V2 = "api/v2";
import { i18n } from "../../i18n";

export async function getLatestNews(cb, offset, pageSize, category) {
  category = category === undefined ? "" : category;

  fetch(
    `${BASE_URL}${API_V2}/${i18n.global.locale.value
    }/news/list?category=${category}&ordering=-pub_date&limit=${pageSize}&offset=${offset *
    pageSize}`
  )
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json["results"], json["count"]);
    });
}

export async function getUzbekistanNews(cb, province) {
  // fetch(`${BASE_URL}${API_V2}/${i18n.global.locale.value}/news/list?province=${province}&ordering=-pub_date&limit=8`)
  fetch(
    `${BASE_URL}${API_V2}/${i18n.global.locale.value}/news/list?province=${province}&category=uzbekistan&ordering=-pub_date&limit=8`
  )
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json["results"]);
    });
}

export async function getNewsDetails(cb, slug, err) {
  fetch(`${BASE_URL}${API_V2}/${i18n.global.locale.value}/news/${slug}/`)
    .then(res => {
      return res.json();
    })
    .catch(() => {
      err();
    })
    .then(json => {
      cb(json);
    });
}

export async function searchNews(cb, query, offset, pageSize) {
  fetch(
    `${BASE_URL}${API_V2}/${i18n.global.locale.value
    }/news/list?search=${query}&limit=${pageSize}&offset=${offset * pageSize}`
  )
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json["results"], json["count"]);
    });
}

export async function getLatestRecommendations(cb, offset, pageSize) {
  fetch(
    `${BASE_URL}${API_V2}/${i18n.global.locale.value
    }/news/list?ordering=-pub_date&limit=${pageSize}&offset=${offset *
    pageSize}`
  )
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json["results"], json["count"]);
    });
}

export async function weatherCurrency(cb) {
  fetch(`${BASE_URL}${API_V2}/wea-cur`)
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json);
    });
}

export async function football(cb) {
  fetch(`${BASE_URL}${API_V2}/football`)
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json);
    });
}

export async function population(cb) {
  fetch(`${BASE_URL}${API_V2}/population`)
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json["population"]);
    });
}

export async function movies(cb) {
  fetch(`${BASE_URL}${API_V2}/movies/`)
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json);
    });
}

export async function getSubCategories(cb, prefferedLang) {
  fetch(`${BASE_URL}${API_V2}/${prefferedLang}/news/sub-categ-list`)
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json);
    });
}

export async function getTags(cb,prefferedLang) {
  fetch(`${BASE_URL}${API_V2}/${prefferedLang}/news/tag-list`)
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json);
    });
}

export async function createArticle(cb, token, newData, prefferedLang, err) {
  fetch(`${BASE_URL}${API_V2}/${prefferedLang}/news/create`, {
    method: "POST",
    body: newData,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .catch(e => {
      err(e);
    })
    .then(async res => {
      if (!res.ok) throw err(res);
      return await cb(res.json());
    });
}

export async function editArticle(cb, id, token, newData, lang, err) {
  fetch(`${BASE_URL}${API_V2}/${lang}/news/crud/${id}`, {
    method: "PATCH",
    body: newData,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .catch(e => {
      err(e);
    })
    .then(res => {
      if (!res.ok) return Promise.reject(res);
      return res.json();
    })
    .catch(e => {
      err(e);
    })
    .then(res => {
      cb(res);
    });
}

export async function getArticle(cb, id, prefferedLang, err) {
  fetch(`${BASE_URL}${API_V2}/${prefferedLang}/news/crud/${id}`, {
    method: "GET"
  })
    .catch(e => {
      err(e);
    })
    .then(res => {
      if (!res.ok) return Promise.reject(res);
      return res.json();
    })
    .catch(e => {
      err(e);
    })
    .then(res => {
      cb(res);
    });
}

export async function getAdminNews(cb, token, offset, pageSize, ordering, search = "", filters = {}) {
  let filtersQuery = "";
  for (const filterName in filters) {
    filtersQuery += `&${filterName}=${filters[filterName]}`;
  }
  fetch(
    `${BASE_URL}${API_V2}/${i18n.global.locale.value
    }/news/admin-list?limit=${pageSize}&offset=${offset *
    pageSize}&ordering=${ordering}${filtersQuery}&search=${search}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
    .then(res => {
      return res.json();
    })
    .then(json => {
      cb(json["results"], json["count"]);
    });
}


export async function sendMessage(cb, id, lang, token, query, err) {
  fetch(`${BASE_URL}${API_V2}/${lang}/news/tg-send/${id}/?${query}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .catch(e => {
      err(e);
    })
    .then(async res => {
      // console.log(res);
      if (!res.ok) throw err(res);
      return await cb(res);
    });
}

// msg
// http://192.168.0.39:8001/en/api/v2/tg-send/{article id}/
// video
// http://192.168.0.39:8001/en/api/v2/tg-send/{article id}/?video=bool
// image
// http://192.168.0.39:8001/en/api/v2/tg-send/{article id}/?image=bool
